import belowTheFold from 'video/belowTheFold';
belowTheFold(
    CBS.Registry.region.prefix +
        '/shows/{slug}/video/xhr/episodes/page/{page}/size/{size}/xs/{excludeShow}/season/{season}/',
    CBS.Registry.region.prefix +
        '/shows/{slug}/xhr/sectionId/{sectionId}/offset/{offset}/limit/{limit}/xs/0/'
);
